import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/index'
import Author from '@/pages/author'
import Photo from '@/pages/photo'

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index
    },
    {
      path: '/author',
      name: 'author',
      component: Author
    },
    {
      path: '/photo',
      name: 'photo',
      component: Photo
    },
  ],

});
router.beforeEach((to,from,next)=>{
  document.body.scrollTop =0;
  document.documentElement.scrollTop =0;
  next();
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js